// Nancy Naden — site content. Swap placeholder links/videos with real ones anytime.
export const SITE = {
  name: "Nancy Naden",
  role: "UK Session Drummer",
  domain: "nancynaden.com",
  email: "nancynaden.enquiry@gmail.com",
  socials: {
    youtube: "https://www.youtube.com/@nancy_drums",
    instagram: "https://www.instagram.com/nancy_drums/?hl=en",
    tiktok: "https://www.tiktok.com/@nancy_drums?lang=en-GB",
  },
};

export const IMAGES = {
  hero: "https://customer-assets.emergentagent.com/job_nancy-drums/artifacts/tz545mzh_Nancy%20and%20Ben__61.webp",
  portrait: "https://customer-assets.emergentagent.com/job_nancy-drums/artifacts/899te597_Nancy%20and%20Ben__30.webp",
  aboutBand: "https://images.unsplash.com/photo-1625801821669-d11f0ede90cd?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
};

export const BIO = `Nancy Naden is a UK freelance drummer. She graduated with a first class BA (Hons) degree specialising in drums at ACM, having studied with Dan Western (Simply Red, Belinda Carlisle) and Toby Drummond (Sir Cliff Richard, Sir Ray Charles). She has a strong focus on hybrid drumming, confidently using Ableton Live and Logic Pro X alongside the Roland SPD-SX.`;

export const BIO_2 = `Her passion lies in bringing tracks to life in a live setting by seamlessly combining programmed elements with acoustic drums to create dynamic, engaging performances. Working across musical projects of every genre, Nancy's versatility, musicality, and professionalism have made her a trusted collaborator for artists.`;

export const ASSOCIATED_WORKS = [
  {
    title: "Lost River - Subnautica Composition",
    artist: "Diego Hamilton",
    url: "https://soundcloud.com/sycle-847983617/lost-river-subnautica",
    image: "/lost-river.png",
    credits: "Recorded drums",
  },
];

export const TESTIMONIALS = [
  {
    quote:
      "Nancy has a natural ability with the kit and has been a pleasure to work with throughout her time at the ACM. Nancy has strong technique, stylistic awareness, internal dynamic, deep knowledge of hybrid application, all of which is supported by a fantastic work ethic & professional attitude. Nancy is certainly a drummer to look out for in the future.",
    name: "Toby Drummond",
    credits:
      "Sir Cliff Richard, Sir Ray Davies, Russell Watson, Shaun Ryder, The Seahorses, Toyah, Robert Fripp",
  },
];

export const CREDENTIALS = [
  { title: "Music Performance", detail: "First Class BA (Hons) Degree in Music Performance specialising in drums, ACM" },
  {
    title: "Tools & Hybrid Setup",
    tools: [
      { name: "Hybrid Drumming", detail: "Blending acoustic kit with programmed elements" },
      { name: "Ableton Live & Logic Pro X", detail: "Live playback, production & arrangement" },
      { name: "Roland SPD-SX PRO", detail: "Electronic pad triggering & sampling" },
    ],
  },
];

export const SKILLS = [
  "Hybrid Drumming",
  "Live Session Work",
  "Ableton Live",
  "Logic Pro X",
  "Roland SPD-SX PRO",
  "Studio Recording",
  "Multi-genre Versatility",
];

// Mix of embedded videos + thumbnail-link videos. Replace youtubeId with real IDs.
export const VIDEOS = [
  { type: "embed", youtubeId: "LToex_E2AGc", title: "Sombr Drum Medley", tag: "Live" },
  { type: "embed", youtubeId: "5Hwn_W9p6W8", title: "Harry Styles Drum Medley", tag: "Live" },
  { type: "embed", youtubeId: "1oVnj4lWJr0", title: "Raye Drum Medley", tag: "Live" },
  { type: "embed", youtubeId: "EAEn8VfAvuo", title: "Zara Larsson - Midnight Sun Album Medley", tag: "Studio" },
  { type: "embed", youtubeId: "3fDvBJxXPJQ", title: "Sabrina Carpenter Drum Medley", tag: "Live" },
  { type: "embed", youtubeId: "EZZBUvr2w4I", start: 840, title: "ACM Studio Lounge - Mia Bennet", tag: "Live" },
];
